'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_math_Equiv$() {
}
export { $c_s_math_Equiv$ as $c_s_math_Equiv$ };
$p = $c_s_math_Equiv$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_math_Equiv$;
/** @constructor */
function $h_s_math_Equiv$() {
}
export { $h_s_math_Equiv$ as $h_s_math_Equiv$ };
$h_s_math_Equiv$.prototype = $p;
var $d_s_math_Equiv$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_math_Equiv$, "scala.math.Equiv$", ({
  uN: 1,
  uO: 1
}));
export { $d_s_math_Equiv$ as $d_s_math_Equiv$ };
var $n_s_math_Equiv$;
function $m_s_math_Equiv$() {
  if ((!$n_s_math_Equiv$)) {
    $n_s_math_Equiv$ = new $c_s_math_Equiv$();
  }
  return $n_s_math_Equiv$;
}
export { $m_s_math_Equiv$ as $m_s_math_Equiv$ };
